var _defs, _path, _g, _g2, _g3, _path2, _g4, _g5, _path3, _path4, _path5, _path6, _g6, _g7, _g8, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSystemIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    zoomAndPan: "magnify",
    viewBox: "0 0 187.5 187.499992",
    height: 250,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    gradientTransform: "matrix(0.730474, 0, 0, 0.730474, 0.000004, 0)",
    y1: 0,
    x2: 255.999987,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "8fd6e7a2f8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 59.199524%, 69.799805%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.192261%, 59.300232%, 69.659424%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.576782%, 59.501648%, 69.380188%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.96283%, 59.70459%, 69.100952%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.348877%, 59.907532%, 68.821716%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.734924%, 60.108948%, 68.544006%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.120972%, 60.31189%, 68.264771%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.507019%, 60.513306%, 67.985535%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.893066%, 60.716248%, 67.706299%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.279114%, 60.919189%, 67.428589%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.665161%, 61.120605%, 67.149353%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.051208%, 61.323547%, 66.870117%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.437256%, 61.524963%, 66.590881%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.823303%, 61.727905%, 66.311646%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.209351%, 61.930847%, 66.033936%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.593872%, 62.132263%, 65.7547%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.979919%, 62.335205%, 65.475464%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.365967%, 62.538147%, 65.196228%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.752014%, 62.739563%, 64.918518%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.138062%, 62.942505%, 64.639282%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.524109%, 63.143921%, 64.360046%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.910156%, 63.346863%, 64.080811%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.296204%, 63.549805%, 63.801575%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.682251%, 63.751221%, 63.523865%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.068298%, 63.954163%, 63.244629%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.454346%, 64.155579%, 62.965393%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.840393%, 64.358521%, 62.686157%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.22644%, 64.561462%, 62.406921%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.612488%, 64.762878%, 62.129211%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.997009%, 64.96582%, 61.849976%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.383057%, 65.167236%, 61.57074%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.769104%, 65.370178%, 61.291504%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.155151%, 65.57312%, 61.013794%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.541199%, 65.774536%, 60.734558%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.927246%, 65.977478%, 60.455322%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.313293%, 66.178894%, 60.176086%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.699341%, 66.381836%, 59.896851%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.085388%, 66.584778%, 59.619141%)",
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.471436%, 66.786194%, 59.339905%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.857483%, 66.989136%, 59.060669%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.24353%, 67.192078%, 58.781433%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.629578%, 67.393494%, 58.502197%)",
    offset: 0.320313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.015625%, 67.596436%, 58.224487%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.400146%, 67.797852%, 57.945251%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.786194%, 68.000793%, 57.666016%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.172241%, 68.203735%, 57.38678%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.558289%, 68.405151%, 57.10907%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.944336%, 68.608093%, 56.829834%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.330383%, 68.809509%, 56.550598%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.716431%, 69.012451%, 56.271362%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.102478%, 69.215393%, 55.992126%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.488525%, 69.416809%, 55.714417%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.874573%, 69.619751%, 55.435181%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.26062%, 69.821167%, 55.155945%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.646667%, 70.024109%, 54.876709%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.032715%, 70.227051%, 54.598999%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.418762%, 70.428467%, 54.319763%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.803284%, 70.631409%, 54.040527%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.189331%, 70.832825%, 53.761292%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.575378%, 71.035767%, 53.482056%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.961426%, 71.238708%, 53.204346%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.347473%, 71.440125%, 52.92511%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.733521%, 71.643066%, 52.645874%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.119568%, 71.846008%, 52.366638%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.505615%, 72.047424%, 52.087402%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.891663%, 72.250366%, 51.809692%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.27771%, 72.451782%, 51.530457%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.663757%, 72.654724%, 51.251221%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.049805%, 72.857666%, 50.971985%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.435852%, 73.059082%, 50.694275%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.821899%, 73.262024%, 50.415039%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.206421%, 73.46344%, 50.135803%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.592468%, 73.666382%, 49.856567%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.978516%, 73.869324%, 49.577332%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.364563%, 74.07074%, 49.299622%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.75061%, 74.273682%, 49.020386%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.136658%, 74.475098%, 48.74115%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.522705%, 74.67804%, 48.461914%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.908752%, 74.880981%, 48.182678%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.2948%, 75.082397%, 47.904968%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.680847%, 75.285339%, 47.625732%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.066895%, 75.486755%, 47.346497%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.452942%, 75.689697%, 47.067261%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.838989%, 75.892639%, 46.789551%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.225037%, 76.094055%, 46.510315%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.609558%, 76.296997%, 46.231079%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.995605%, 76.498413%, 45.951843%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.381653%, 76.701355%, 45.672607%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.7677%, 76.904297%, 45.394897%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.153748%, 77.105713%, 45.115662%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.539795%, 77.308655%, 44.836426%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.925842%, 77.511597%, 44.55719%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.31189%, 77.713013%, 44.27948%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.697937%, 77.915955%, 44.000244%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.083984%, 78.117371%, 43.721008%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.470032%, 78.320312%, 43.441772%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.856079%, 78.523254%, 43.162537%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.242126%, 78.72467%, 42.884827%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.628174%, 78.927612%, 42.605591%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.012695%, 79.129028%, 42.326355%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.398743%, 79.33197%, 42.047119%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.78479%, 79.534912%, 41.767883%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.170837%, 79.736328%, 41.490173%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.556885%, 79.93927%, 41.210938%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.942932%, 80.140686%, 40.931702%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.328979%, 80.343628%, 40.652466%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.715027%, 80.54657%, 40.374756%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.101074%, 80.747986%, 40.09552%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.487122%, 80.950928%, 39.816284%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.873169%, 81.152344%, 39.537048%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.259216%, 81.355286%, 39.257812%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.645264%, 81.558228%, 38.980103%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.031311%, 81.759644%, 38.700867%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.415833%, 81.962585%, 38.421631%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.80188%, 82.165527%, 38.142395%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.187927%, 82.366943%, 37.863159%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.573975%, 82.569885%, 37.585449%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.960022%, 82.771301%, 37.306213%)",
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.346069%, 82.974243%, 37.026978%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.732117%, 83.177185%, 36.747742%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.118164%, 83.378601%, 36.470032%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.504211%, 83.581543%, 36.190796%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.890259%, 83.782959%, 35.91156%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.276306%, 83.985901%, 35.632324%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.662354%, 84.188843%, 35.353088%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.048401%, 84.390259%, 35.075378%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.432922%, 84.593201%, 34.796143%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.81897%, 84.794617%, 34.516907%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.205017%, 84.997559%, 34.237671%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "108f0f487f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.46875 70.574219 L 88 70.574219 L 88 96 L 40.46875 96 Z M 40.46875 70.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "229880ddfe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 90 70.574219 L 116.019531 70.574219 L 116.019531 118 L 90 118 Z M 90 70.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c18443d9f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68 120 L 116.019531 120 L 116.019531 146.125 L 68 146.125 Z M 68 120 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d755b4894e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.46875 98 L 66 98 L 66 146.125 L 40.46875 146.125 Z M 40.46875 98 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee40b0928b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 90 70.574219 L 94 70.574219 L 94 81 L 90 81 Z M 90 70.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "929d9e028b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 90 136 L 94 136 L 94 146.125 L 90 146.125 Z M 90 136 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d446926e4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.46875 70.574219 L 44 70.574219 L 44 96 L 40.46875 96 Z M 40.46875 70.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b946bcde32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.46875 120 L 44 120 L 44 146.125 L 40.46875 146.125 Z M 40.46875 120 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#8fd6e7a2f8)",
    d: "M 0 0 L 0 187 L 187 187 L 187 0 Z M 0 0 ",
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#108f0f487f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#64c8f0",
    d: "M 87.6875 83.167969 L 81.390625 76.871094 L 81.390625 80.019531 L 65.652344 80.019531 L 65.652344 70.574219 L 40.46875 70.574219 L 40.46875 95.757812 L 49.914062 95.757812 L 49.914062 92.609375 C 49.914062 90.871094 51.324219 89.464844 53.0625 89.464844 C 54.800781 89.464844 56.210938 90.871094 56.210938 92.609375 L 56.210938 95.757812 L 65.652344 95.757812 L 65.652344 86.316406 L 81.390625 86.316406 L 81.390625 89.464844 Z M 87.6875 83.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#229880ddfe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3cc8b4",
    d: "M 116.019531 95.757812 L 116.019531 70.574219 L 90.835938 70.574219 L 90.835938 80.019531 L 93.984375 80.019531 C 95.722656 80.019531 97.132812 81.429688 97.132812 83.167969 C 97.132812 84.90625 95.722656 86.316406 93.984375 86.316406 L 90.835938 86.316406 L 90.835938 95.757812 L 100.28125 95.757812 L 100.28125 111.5 L 97.132812 111.5 L 103.425781 117.792969 L 109.722656 111.5 L 106.574219 111.5 L 106.574219 95.757812 Z M 116.019531 95.757812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c18443d9f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fab400",
    d: "M 106.574219 120.941406 L 106.574219 124.089844 C 106.574219 125.828125 105.167969 127.238281 103.425781 127.238281 C 101.6875 127.238281 100.28125 125.828125 100.28125 124.089844 L 100.28125 120.941406 L 90.835938 120.941406 L 90.835938 130.386719 L 75.097656 130.386719 L 75.097656 127.238281 L 68.800781 133.535156 L 75.097656 139.828125 L 75.097656 136.679688 L 90.835938 136.679688 L 90.835938 146.125 L 116.019531 146.125 L 116.019531 120.941406 Z M 106.574219 120.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc9600",
    d: "M 75.097656 130.386719 L 75.097656 127.238281 L 68.800781 133.535156 L 75.097656 139.828125 L 75.097656 136.679688 L 71.949219 133.535156 Z M 75.097656 130.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d755b4894e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fa6450",
    d: "M 62.675781 130.386719 L 65.652344 130.386719 L 65.652344 120.941406 L 56.210938 120.941406 L 56.210938 105.203125 L 59.359375 105.203125 L 53.0625 98.90625 L 46.765625 105.203125 L 49.914062 105.203125 L 49.914062 120.941406 L 40.46875 120.941406 L 40.46875 146.125 L 65.652344 146.125 L 65.652344 136.679688 L 62.503906 136.679688 C 60.765625 136.683594 59.355469 135.273438 59.355469 133.535156 C 59.355469 133.355469 59.371094 133.179688 59.398438 133.003906 C 59.714844 131.453125 61.09375 130.351562 62.675781 130.386719 Z M 62.675781 130.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee40b0928b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1eaa96",
    d: "M 90.835938 70.574219 L 93.984375 70.574219 L 93.984375 80.019531 L 90.835938 80.019531 Z M 90.835938 70.574219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1eaa96",
    d: "M 90.835938 86.316406 L 93.984375 86.316406 L 93.984375 95.757812 L 90.835938 95.757812 Z M 90.835938 86.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1eaa96",
    d: "M 100.28125 83.167969 C 100.28125 81.429688 98.871094 80.019531 97.132812 80.019531 L 93.984375 80.019531 C 95.722656 80.019531 97.132812 81.429688 97.132812 83.167969 C 97.132812 84.90625 95.722656 86.316406 93.984375 86.316406 L 97.132812 86.316406 C 98.871094 86.316406 100.28125 84.90625 100.28125 83.167969 Z M 100.28125 83.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc9600",
    d: "M 106.574219 127.238281 C 108.3125 127.238281 109.722656 125.828125 109.722656 124.089844 L 109.722656 120.941406 L 106.574219 120.941406 L 106.574219 124.089844 C 106.574219 125.210938 105.972656 126.242188 105 126.800781 C 105.476562 127.082031 106.019531 127.234375 106.574219 127.238281 Z M 106.574219 127.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc9600",
    d: "M 90.835938 120.941406 L 93.984375 120.941406 L 93.984375 130.386719 L 90.835938 130.386719 Z M 90.835938 120.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#929d9e028b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dc9600",
    d: "M 90.835938 136.679688 L 93.984375 136.679688 L 93.984375 146.125 L 90.835938 146.125 Z M 90.835938 136.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d446926e4d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#46aad2",
    d: "M 40.46875 70.574219 L 43.617188 70.574219 L 43.617188 95.757812 L 40.46875 95.757812 Z M 40.46875 70.574219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b946bcde32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dc4632",
    d: "M 40.46875 120.941406 L 43.617188 120.941406 L 43.617188 146.125 L 40.46875 146.125 Z M 40.46875 120.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc4632",
    d: "M 54.636719 100.480469 L 53.0625 98.90625 L 46.765625 105.203125 L 49.914062 105.203125 Z M 54.636719 100.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc4632",
    d: "M 49.914062 105.203125 L 53.0625 105.203125 L 53.0625 120.941406 L 49.914062 120.941406 Z M 49.914062 105.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1eaa96",
    d: "M 100.28125 95.757812 L 103.425781 95.757812 L 103.425781 111.5 L 100.28125 111.5 Z M 100.28125 95.757812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1eaa96",
    d: "M 100.28125 111.5 L 97.132812 111.5 L 103.425781 117.792969 L 105 116.21875 Z M 100.28125 111.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M 93.984375 111.5 L 93.984375 105.203125 L 90.421875 105.203125 C 90.128906 104.066406 89.679688 102.976562 89.082031 101.964844 L 91.601562 99.445312 L 87.148438 94.992188 L 84.632812 97.511719 C 83.621094 96.914062 82.53125 96.464844 81.390625 96.171875 L 81.390625 92.609375 L 75.097656 92.609375 L 75.097656 96.171875 C 73.960938 96.464844 72.871094 96.914062 71.859375 97.511719 L 69.339844 94.992188 L 64.886719 99.445312 L 67.40625 101.964844 C 66.808594 102.976562 66.359375 104.066406 66.066406 105.203125 L 62.503906 105.203125 L 62.503906 111.5 L 66.066406 111.5 C 66.359375 112.636719 66.808594 113.726562 67.40625 114.738281 L 64.886719 117.253906 L 69.339844 121.707031 L 71.859375 119.1875 C 72.871094 119.785156 73.960938 120.234375 75.097656 120.53125 L 75.097656 124.089844 L 81.390625 124.089844 L 81.390625 120.53125 C 82.53125 120.238281 83.621094 119.785156 84.632812 119.1875 L 87.148438 121.707031 L 91.601562 117.253906 L 89.082031 114.738281 C 89.679688 113.726562 90.128906 112.636719 90.421875 111.5 Z M 78.246094 114.644531 C 74.769531 114.644531 71.949219 111.828125 71.949219 108.351562 C 71.949219 104.875 74.769531 102.054688 78.246094 102.054688 C 81.722656 102.054688 84.539062 104.875 84.539062 108.351562 C 84.539062 111.828125 81.722656 114.644531 78.246094 114.644531 Z M 78.246094 114.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M 75.003906 97.511719 C 76.015625 96.914062 77.109375 96.464844 78.246094 96.171875 L 78.246094 92.609375 L 75.097656 92.609375 L 75.097656 96.171875 C 74.730469 96.265625 74.378906 96.40625 74.023438 96.53125 Z M 75.003906 97.511719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M 75.003906 119.1875 L 74.023438 120.171875 C 74.378906 120.296875 74.730469 120.433594 75.097656 120.53125 L 75.097656 124.089844 L 78.246094 124.089844 L 78.246094 120.53125 C 77.109375 120.238281 76.015625 119.785156 75.003906 119.1875 Z M 75.003906 119.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M 81.390625 102.054688 C 80.859375 102.0625 80.332031 102.136719 79.820312 102.277344 C 83.171875 103.132812 85.199219 106.542969 84.34375 109.894531 C 83.78125 112.121094 82.042969 113.855469 79.820312 114.421875 C 80.332031 114.566406 80.859375 114.640625 81.390625 114.644531 C 84.871094 114.644531 87.6875 111.828125 87.6875 108.351562 C 87.6875 104.875 84.871094 102.054688 81.390625 102.054688 Z M 81.390625 102.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M 66.066406 105.203125 L 69.214844 105.203125 C 69.507812 104.066406 69.957031 102.976562 70.554688 101.964844 L 68.035156 99.445312 L 70.914062 96.566406 L 69.339844 94.992188 L 64.886719 99.445312 L 67.40625 101.964844 C 66.808594 102.976562 66.359375 104.066406 66.066406 105.203125 Z M 66.066406 105.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M 68.039062 117.253906 L 70.554688 114.734375 C 69.960938 113.726562 69.507812 112.636719 69.214844 111.5 L 66.066406 111.5 C 66.359375 112.636719 66.808594 113.726562 67.40625 114.738281 L 64.886719 117.253906 L 69.339844 121.707031 L 70.914062 120.132812 Z M 68.039062 117.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M 62.503906 105.203125 L 65.652344 105.203125 L 65.652344 111.5 L 62.503906 111.5 Z M 62.503906 105.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.342877, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.875 0.171875 C 3.1875 0.171875 2.515625 0.0859375 1.859375 -0.078125 C 1.203125 -0.253906 0.671875 -0.488281 0.265625 -0.78125 L 1.0625 -2.5625 C 1.445312 -2.3125 1.890625 -2.109375 2.390625 -1.953125 C 2.898438 -1.796875 3.398438 -1.71875 3.890625 -1.71875 C 4.828125 -1.71875 5.296875 -1.953125 5.296875 -2.421875 C 5.296875 -2.660156 5.160156 -2.835938 4.890625 -2.953125 C 4.628906 -3.078125 4.203125 -3.207031 3.609375 -3.34375 C 2.960938 -3.476562 2.421875 -3.625 1.984375 -3.78125 C 1.554688 -3.945312 1.1875 -4.203125 0.875 -4.546875 C 0.5625 -4.898438 0.40625 -5.378906 0.40625 -5.984375 C 0.40625 -6.503906 0.546875 -6.972656 0.828125 -7.390625 C 1.117188 -7.816406 1.546875 -8.148438 2.109375 -8.390625 C 2.679688 -8.640625 3.382812 -8.765625 4.21875 -8.765625 C 4.78125 -8.765625 5.332031 -8.703125 5.875 -8.578125 C 6.425781 -8.453125 6.910156 -8.265625 7.328125 -8.015625 L 6.578125 -6.21875 C 5.765625 -6.65625 4.972656 -6.875 4.203125 -6.875 C 3.710938 -6.875 3.359375 -6.800781 3.140625 -6.65625 C 2.921875 -6.519531 2.8125 -6.335938 2.8125 -6.109375 C 2.8125 -5.878906 2.941406 -5.707031 3.203125 -5.59375 C 3.460938 -5.476562 3.882812 -5.359375 4.46875 -5.234375 C 5.125 -5.085938 5.664062 -4.9375 6.09375 -4.78125 C 6.53125 -4.625 6.90625 -4.367188 7.21875 -4.015625 C 7.53125 -3.671875 7.6875 -3.203125 7.6875 -2.609375 C 7.6875 -2.085938 7.539062 -1.617188 7.25 -1.203125 C 6.96875 -0.785156 6.539062 -0.453125 5.96875 -0.203125 C 5.394531 0.046875 4.695312 0.171875 3.875 0.171875 Z M 3.875 0.171875 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.282855, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.765625 -6.65625 L 4.890625 0.265625 C 4.554688 1.085938 4.144531 1.664062 3.65625 2 C 3.175781 2.332031 2.585938 2.5 1.890625 2.5 C 1.535156 2.5 1.179688 2.441406 0.828125 2.328125 C 0.472656 2.210938 0.1875 2.066406 -0.03125 1.890625 L 0.78125 0.265625 C 0.90625 0.378906 1.054688 0.472656 1.234375 0.546875 C 1.421875 0.617188 1.613281 0.65625 1.8125 0.65625 C 2.03125 0.65625 2.207031 0.609375 2.34375 0.515625 C 2.488281 0.421875 2.613281 0.28125 2.71875 0.09375 L -0.140625 -6.65625 L 2.265625 -6.65625 L 3.890625 -2.59375 L 5.53125 -6.65625 Z M 7.765625 -6.65625 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.891493, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.171875 0.109375 C 2.609375 0.109375 2.054688 0.046875 1.515625 -0.078125 C 0.984375 -0.203125 0.550781 -0.367188 0.21875 -0.578125 L 0.921875 -2.171875 C 1.222656 -1.984375 1.582031 -1.832031 2 -1.71875 C 2.414062 -1.613281 2.832031 -1.5625 3.25 -1.5625 C 3.625 -1.5625 3.890625 -1.597656 4.046875 -1.671875 C 4.203125 -1.753906 4.28125 -1.867188 4.28125 -2.015625 C 4.28125 -2.160156 4.179688 -2.265625 3.984375 -2.328125 C 3.796875 -2.390625 3.492188 -2.445312 3.078125 -2.5 C 2.546875 -2.570312 2.09375 -2.660156 1.71875 -2.765625 C 1.351562 -2.867188 1.035156 -3.0625 0.765625 -3.34375 C 0.492188 -3.632812 0.359375 -4.039062 0.359375 -4.5625 C 0.359375 -4.976562 0.484375 -5.351562 0.734375 -5.6875 C 0.992188 -6.019531 1.363281 -6.28125 1.84375 -6.46875 C 2.332031 -6.664062 2.914062 -6.765625 3.59375 -6.765625 C 4.082031 -6.765625 4.5625 -6.710938 5.03125 -6.609375 C 5.507812 -6.515625 5.90625 -6.378906 6.21875 -6.203125 L 5.53125 -4.625 C 4.9375 -4.945312 4.296875 -5.109375 3.609375 -5.109375 C 3.242188 -5.109375 2.972656 -5.0625 2.796875 -4.96875 C 2.628906 -4.882812 2.546875 -4.773438 2.546875 -4.640625 C 2.546875 -4.484375 2.640625 -4.375 2.828125 -4.3125 C 3.015625 -4.25 3.328125 -4.1875 3.765625 -4.125 C 4.304688 -4.039062 4.753906 -3.945312 5.109375 -3.84375 C 5.472656 -3.738281 5.785156 -3.546875 6.046875 -3.265625 C 6.316406 -2.984375 6.453125 -2.585938 6.453125 -2.078125 C 6.453125 -1.660156 6.328125 -1.285156 6.078125 -0.953125 C 5.828125 -0.617188 5.453125 -0.359375 4.953125 -0.171875 C 4.460938 0.015625 3.867188 0.109375 3.171875 0.109375 Z M 3.171875 0.109375 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.604274, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.34375 -0.265625 C 5.144531 -0.148438 4.90625 -0.0625 4.625 0 C 4.34375 0.0703125 4.039062 0.109375 3.71875 0.109375 C 2.851562 0.109375 2.1875 -0.101562 1.71875 -0.53125 C 1.25 -0.957031 1.015625 -1.59375 1.015625 -2.4375 L 1.015625 -4.671875 L 0.046875 -4.671875 L 0.046875 -6.40625 L 1.015625 -6.40625 L 1.015625 -8.140625 L 3.359375 -8.140625 L 3.359375 -6.40625 L 4.875 -6.40625 L 4.875 -4.671875 L 3.359375 -4.671875 L 3.359375 -2.453125 C 3.359375 -2.210938 3.421875 -2.023438 3.546875 -1.890625 C 3.671875 -1.753906 3.835938 -1.6875 4.046875 -1.6875 C 4.316406 -1.6875 4.554688 -1.757812 4.765625 -1.90625 Z M 5.34375 -0.265625 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.089859, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.546875 -3.3125 C 7.546875 -3.300781 7.535156 -3.109375 7.515625 -2.734375 L 2.671875 -2.734375 C 2.773438 -2.390625 2.96875 -2.125 3.25 -1.9375 C 3.53125 -1.757812 3.882812 -1.671875 4.3125 -1.671875 C 4.632812 -1.671875 4.910156 -1.710938 5.140625 -1.796875 C 5.367188 -1.890625 5.601562 -2.039062 5.84375 -2.25 L 7.078125 -0.96875 C 6.429688 -0.25 5.484375 0.109375 4.234375 0.109375 C 3.453125 0.109375 2.765625 -0.0351562 2.171875 -0.328125 C 1.585938 -0.628906 1.132812 -1.039062 0.8125 -1.5625 C 0.488281 -2.082031 0.328125 -2.675781 0.328125 -3.34375 C 0.328125 -4 0.484375 -4.582031 0.796875 -5.09375 C 1.117188 -5.613281 1.554688 -6.019531 2.109375 -6.3125 C 2.671875 -6.613281 3.296875 -6.765625 3.984375 -6.765625 C 4.648438 -6.765625 5.253906 -6.625 5.796875 -6.34375 C 6.335938 -6.070312 6.765625 -5.675781 7.078125 -5.15625 C 7.390625 -4.644531 7.546875 -4.03125 7.546875 -3.3125 Z M 4 -5.109375 C 3.644531 -5.109375 3.34375 -5.003906 3.09375 -4.796875 C 2.851562 -4.597656 2.703125 -4.320312 2.640625 -3.96875 L 5.359375 -3.96875 C 5.296875 -4.320312 5.144531 -4.597656 4.90625 -4.796875 C 4.664062 -5.003906 4.363281 -5.109375 4 -5.109375 Z M 4 -5.109375 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.968477, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.421875 -6.765625 C 10.234375 -6.765625 10.882812 -6.519531 11.375 -6.03125 C 11.863281 -5.539062 12.109375 -4.800781 12.109375 -3.8125 L 12.109375 0 L 9.78125 0 L 9.78125 -3.421875 C 9.78125 -3.890625 9.691406 -4.234375 9.515625 -4.453125 C 9.335938 -4.679688 9.085938 -4.796875 8.765625 -4.796875 C 8.410156 -4.796875 8.128906 -4.671875 7.921875 -4.421875 C 7.710938 -4.171875 7.609375 -3.796875 7.609375 -3.296875 L 7.609375 0 L 5.265625 0 L 5.265625 -3.421875 C 5.265625 -4.335938 4.929688 -4.796875 4.265625 -4.796875 C 3.898438 -4.796875 3.609375 -4.671875 3.390625 -4.421875 C 3.179688 -4.171875 3.078125 -3.796875 3.078125 -3.296875 L 3.078125 0 L 0.75 0 L 0.75 -6.65625 L 2.96875 -6.65625 L 2.96875 -5.953125 C 3.21875 -6.222656 3.507812 -6.425781 3.84375 -6.5625 C 4.1875 -6.695312 4.5625 -6.765625 4.96875 -6.765625 C 5.425781 -6.765625 5.835938 -6.675781 6.203125 -6.5 C 6.578125 -6.332031 6.878906 -6.070312 7.109375 -5.71875 C 7.367188 -6.050781 7.695312 -6.304688 8.09375 -6.484375 C 8.5 -6.671875 8.941406 -6.765625 9.421875 -6.765625 Z M 9.421875 -6.765625 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.79271, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.36386, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.859375 -8.59375 L 3.296875 -8.59375 L 3.296875 0 L 0.859375 0 Z M 0.859375 -8.59375 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.524069, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.078125 -6.765625 C 5.910156 -6.765625 6.578125 -6.519531 7.078125 -6.03125 C 7.578125 -5.539062 7.828125 -4.800781 7.828125 -3.8125 L 7.828125 0 L 5.5 0 L 5.5 -3.421875 C 5.5 -4.335938 5.132812 -4.796875 4.40625 -4.796875 C 4.007812 -4.796875 3.6875 -4.660156 3.4375 -4.390625 C 3.195312 -4.128906 3.078125 -3.738281 3.078125 -3.21875 L 3.078125 0 L 0.75 0 L 0.75 -6.65625 L 2.96875 -6.65625 L 2.96875 -5.9375 C 3.226562 -6.207031 3.539062 -6.410156 3.90625 -6.546875 C 4.269531 -6.691406 4.660156 -6.765625 5.078125 -6.765625 Z M 5.078125 -6.765625 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.065374, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.34375 -0.265625 C 5.144531 -0.148438 4.90625 -0.0625 4.625 0 C 4.34375 0.0703125 4.039062 0.109375 3.71875 0.109375 C 2.851562 0.109375 2.1875 -0.101562 1.71875 -0.53125 C 1.25 -0.957031 1.015625 -1.59375 1.015625 -2.4375 L 1.015625 -4.671875 L 0.046875 -4.671875 L 0.046875 -6.40625 L 1.015625 -6.40625 L 1.015625 -8.140625 L 3.359375 -8.140625 L 3.359375 -6.40625 L 4.875 -6.40625 L 4.875 -4.671875 L 3.359375 -4.671875 L 3.359375 -2.453125 C 3.359375 -2.210938 3.421875 -2.023438 3.546875 -1.890625 C 3.671875 -1.753906 3.835938 -1.6875 4.046875 -1.6875 C 4.316406 -1.6875 4.554688 -1.757812 4.765625 -1.90625 Z M 5.34375 -0.265625 "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.550959, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.546875 -3.3125 C 7.546875 -3.300781 7.535156 -3.109375 7.515625 -2.734375 L 2.671875 -2.734375 C 2.773438 -2.390625 2.96875 -2.125 3.25 -1.9375 C 3.53125 -1.757812 3.882812 -1.671875 4.3125 -1.671875 C 4.632812 -1.671875 4.910156 -1.710938 5.140625 -1.796875 C 5.367188 -1.890625 5.601562 -2.039062 5.84375 -2.25 L 7.078125 -0.96875 C 6.429688 -0.25 5.484375 0.109375 4.234375 0.109375 C 3.453125 0.109375 2.765625 -0.0351562 2.171875 -0.328125 C 1.585938 -0.628906 1.132812 -1.039062 0.8125 -1.5625 C 0.488281 -2.082031 0.328125 -2.675781 0.328125 -3.34375 C 0.328125 -4 0.484375 -4.582031 0.796875 -5.09375 C 1.117188 -5.613281 1.554688 -6.019531 2.109375 -6.3125 C 2.671875 -6.613281 3.296875 -6.765625 3.984375 -6.765625 C 4.648438 -6.765625 5.253906 -6.625 5.796875 -6.34375 C 6.335938 -6.070312 6.765625 -5.675781 7.078125 -5.15625 C 7.390625 -4.644531 7.546875 -4.03125 7.546875 -3.3125 Z M 4 -5.109375 C 3.644531 -5.109375 3.34375 -5.003906 3.09375 -4.796875 C 2.851562 -4.597656 2.703125 -4.320312 2.640625 -3.96875 L 5.359375 -3.96875 C 5.296875 -4.320312 5.144531 -4.597656 4.90625 -4.796875 C 4.664062 -5.003906 4.363281 -5.109375 4 -5.109375 Z M 4 -5.109375 "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.429577, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.90625 -6.65625 L 7.90625 -1.21875 C 7.90625 0.0195312 7.566406 0.945312 6.890625 1.5625 C 6.222656 2.1875 5.257812 2.5 4 2.5 C 3.34375 2.5 2.726562 2.421875 2.15625 2.265625 C 1.582031 2.117188 1.097656 1.90625 0.703125 1.625 L 1.546875 -0.015625 C 1.816406 0.203125 2.15625 0.375 2.5625 0.5 C 2.976562 0.632812 3.390625 0.703125 3.796875 0.703125 C 4.410156 0.703125 4.859375 0.566406 5.140625 0.296875 C 5.429688 0.0234375 5.578125 -0.375 5.578125 -0.90625 L 5.578125 -1.125 C 5.128906 -0.601562 4.46875 -0.34375 3.59375 -0.34375 C 3.007812 -0.34375 2.46875 -0.472656 1.96875 -0.734375 C 1.46875 -1.003906 1.066406 -1.382812 0.765625 -1.875 C 0.472656 -2.363281 0.328125 -2.925781 0.328125 -3.5625 C 0.328125 -4.1875 0.472656 -4.742188 0.765625 -5.234375 C 1.066406 -5.722656 1.46875 -6.097656 1.96875 -6.359375 C 2.46875 -6.628906 3.007812 -6.765625 3.59375 -6.765625 C 4.539062 -6.765625 5.238281 -6.457031 5.6875 -5.84375 L 5.6875 -6.65625 Z M 4.15625 -2.203125 C 4.570312 -2.203125 4.914062 -2.328125 5.1875 -2.578125 C 5.457031 -2.828125 5.59375 -3.15625 5.59375 -3.5625 C 5.59375 -3.957031 5.457031 -4.28125 5.1875 -4.53125 C 4.925781 -4.78125 4.582031 -4.90625 4.15625 -4.90625 C 3.726562 -4.90625 3.375 -4.78125 3.09375 -4.53125 C 2.820312 -4.28125 2.6875 -3.957031 2.6875 -3.5625 C 2.6875 -3.15625 2.828125 -2.828125 3.109375 -2.578125 C 3.390625 -2.328125 3.738281 -2.203125 4.15625 -2.203125 Z M 4.15625 -2.203125 "
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.081332, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.96875 -5.859375 C 3.207031 -6.160156 3.515625 -6.382812 3.890625 -6.53125 C 4.273438 -6.6875 4.710938 -6.765625 5.203125 -6.765625 L 5.203125 -4.671875 C 4.992188 -4.691406 4.816406 -4.703125 4.671875 -4.703125 C 4.179688 -4.703125 3.789062 -4.566406 3.5 -4.296875 C 3.21875 -4.023438 3.078125 -3.613281 3.078125 -3.0625 L 3.078125 0 L 0.75 0 L 0.75 -6.65625 L 2.96875 -6.65625 Z M 2.96875 -5.859375 "
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.517827, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.59375 -6.765625 C 4.695312 -6.765625 5.535156 -6.507812 6.109375 -6 C 6.691406 -5.5 6.984375 -4.734375 6.984375 -3.703125 L 6.984375 0 L 4.8125 0 L 4.8125 -0.859375 C 4.476562 -0.210938 3.820312 0.109375 2.84375 0.109375 C 2.332031 0.109375 1.890625 0.0195312 1.515625 -0.15625 C 1.140625 -0.34375 0.851562 -0.585938 0.65625 -0.890625 C 0.46875 -1.191406 0.375 -1.539062 0.375 -1.9375 C 0.375 -2.570312 0.613281 -3.0625 1.09375 -3.40625 C 1.570312 -3.757812 2.316406 -3.9375 3.328125 -3.9375 L 4.65625 -3.9375 C 4.613281 -4.632812 4.144531 -4.984375 3.25 -4.984375 C 2.925781 -4.984375 2.597656 -4.929688 2.265625 -4.828125 C 1.941406 -4.722656 1.664062 -4.582031 1.4375 -4.40625 L 0.65625 -6 C 1.019531 -6.238281 1.460938 -6.425781 1.984375 -6.5625 C 2.515625 -6.695312 3.050781 -6.765625 3.59375 -6.765625 Z M 3.5 -1.359375 C 3.769531 -1.359375 4.003906 -1.421875 4.203125 -1.546875 C 4.410156 -1.679688 4.5625 -1.878906 4.65625 -2.140625 L 4.65625 -2.71875 L 3.640625 -2.71875 C 2.960938 -2.71875 2.625 -2.488281 2.625 -2.03125 C 2.625 -1.832031 2.703125 -1.671875 2.859375 -1.546875 C 3.015625 -1.421875 3.226562 -1.359375 3.5 -1.359375 Z M 3.5 -1.359375 "
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.224646, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.34375 -0.265625 C 5.144531 -0.148438 4.90625 -0.0625 4.625 0 C 4.34375 0.0703125 4.039062 0.109375 3.71875 0.109375 C 2.851562 0.109375 2.1875 -0.101562 1.71875 -0.53125 C 1.25 -0.957031 1.015625 -1.59375 1.015625 -2.4375 L 1.015625 -4.671875 L 0.046875 -4.671875 L 0.046875 -6.40625 L 1.015625 -6.40625 L 1.015625 -8.140625 L 3.359375 -8.140625 L 3.359375 -6.40625 L 4.875 -6.40625 L 4.875 -4.671875 L 3.359375 -4.671875 L 3.359375 -2.453125 C 3.359375 -2.210938 3.421875 -2.023438 3.546875 -1.890625 C 3.671875 -1.753906 3.835938 -1.6875 4.046875 -1.6875 C 4.316406 -1.6875 4.554688 -1.757812 4.765625 -1.90625 Z M 5.34375 -0.265625 "
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.710231, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.75 -6.65625 L 3.078125 -6.65625 L 3.078125 0 L 0.75 0 Z M 1.90625 -7.390625 C 1.476562 -7.390625 1.132812 -7.507812 0.875 -7.75 C 0.613281 -7.988281 0.484375 -8.285156 0.484375 -8.640625 C 0.484375 -8.984375 0.613281 -9.273438 0.875 -9.515625 C 1.132812 -9.753906 1.476562 -9.875 1.90625 -9.875 C 2.332031 -9.875 2.675781 -9.757812 2.9375 -9.53125 C 3.195312 -9.3125 3.328125 -9.023438 3.328125 -8.671875 C 3.328125 -8.304688 3.195312 -8 2.9375 -7.75 C 2.675781 -7.507812 2.332031 -7.390625 1.90625 -7.390625 Z M 1.90625 -7.390625 "
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.551371, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.09375 0.109375 C 3.375 0.109375 2.726562 -0.0351562 2.15625 -0.328125 C 1.582031 -0.628906 1.132812 -1.039062 0.8125 -1.5625 C 0.488281 -2.082031 0.328125 -2.675781 0.328125 -3.34375 C 0.328125 -4 0.488281 -4.585938 0.8125 -5.109375 C 1.132812 -5.628906 1.582031 -6.035156 2.15625 -6.328125 C 2.726562 -6.617188 3.375 -6.765625 4.09375 -6.765625 C 4.8125 -6.765625 5.457031 -6.617188 6.03125 -6.328125 C 6.601562 -6.035156 7.046875 -5.628906 7.359375 -5.109375 C 7.679688 -4.585938 7.84375 -4 7.84375 -3.34375 C 7.84375 -2.675781 7.679688 -2.082031 7.359375 -1.5625 C 7.046875 -1.039062 6.601562 -0.628906 6.03125 -0.328125 C 5.457031 -0.0351562 4.8125 0.109375 4.09375 0.109375 Z M 4.09375 -1.75 C 4.5 -1.75 4.832031 -1.890625 5.09375 -2.171875 C 5.351562 -2.453125 5.484375 -2.84375 5.484375 -3.34375 C 5.484375 -3.832031 5.351562 -4.210938 5.09375 -4.484375 C 4.832031 -4.765625 4.5 -4.90625 4.09375 -4.90625 C 3.675781 -4.90625 3.335938 -4.765625 3.078125 -4.484375 C 2.816406 -4.210938 2.6875 -3.832031 2.6875 -3.34375 C 2.6875 -2.84375 2.816406 -2.453125 3.078125 -2.171875 C 3.335938 -1.890625 3.675781 -1.75 4.09375 -1.75 Z M 4.09375 -1.75 "
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.724518, 52.34295)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.078125 -6.765625 C 5.910156 -6.765625 6.578125 -6.519531 7.078125 -6.03125 C 7.578125 -5.539062 7.828125 -4.800781 7.828125 -3.8125 L 7.828125 0 L 5.5 0 L 5.5 -3.421875 C 5.5 -4.335938 5.132812 -4.796875 4.40625 -4.796875 C 4.007812 -4.796875 3.6875 -4.660156 3.4375 -4.390625 C 3.195312 -4.128906 3.078125 -3.738281 3.078125 -3.21875 L 3.078125 0 L 0.75 0 L 0.75 -6.65625 L 2.96875 -6.65625 L 2.96875 -5.9375 C 3.226562 -6.207031 3.539062 -6.410156 3.90625 -6.546875 C 4.269531 -6.691406 4.660156 -6.765625 5.078125 -6.765625 Z M 5.078125 -6.765625 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIntegration);
export default __webpack_public_path__ + "static/media/System_Integration.4684120677f8d28a2ac28121a4e24389.svg";
export { ForwardRef as ReactComponent };